/** Live SP app host — dashboard Feeds tab hidden here until launch. */
export const FEATURE_OF_THE_WEEK_PRODUCTION_APP_HOST = "app.vertex360.io";

/**
 * Whether the Feature of the Week tab appears in SP dashboard Feeds.
 * Off on production by default; override with REACT_APP_FEATURE_OF_THE_WEEK_DASHBOARD_ENABLED.
 */
export function resolveFeatureOfTheWeekDashboardFeedsEnabled({
  envFlag = process.env.REACT_APP_FEATURE_OF_THE_WEEK_DASHBOARD_ENABLED,
  appEnv = process.env.REACT_APP_ENV,
  hostname = "",
} = {}) {
  if (envFlag === "true") return true;
  if (envFlag === "false") return false;
  if (appEnv === "production") return false;
  if (hostname === FEATURE_OF_THE_WEEK_PRODUCTION_APP_HOST) return false;
  return true;
}

export const isFeatureOfTheWeekDashboardFeedsEnabled = () =>
  resolveFeatureOfTheWeekDashboardFeedsEnabled({
    hostname:
      typeof window !== "undefined" ? window.location.hostname : "",
  });
